import UQIcon from '../../icon';
import './style.scss';
import { NavbarItemProps } from './interface';
import NavbarSubitem from '../navbar-subitem';
import React, { useState, useEffect, memo } from 'react';

const NavbarItem = (props: NavbarItemProps) => {
  const { size = 'normal', horizontalCollapsed = false } = props;
  
  const isActive = (link: string) => {
    return link === props.location.pathname || props.location.pathname.startsWith(link + '/');
  };

  const [collapsed, setCollapsed] = useState<Boolean>(props.isCollapsed ?? false);
  const [collapserIcon, setCollapserIcon] = useState<string>(collapsed ? 'chevron-down' : 'chevron-up');

  useEffect(() => {
    setCollapsed(props.isCollapsed ?? false);
    setCollapserIcon(props.isCollapsed ? 'chevron-down' : 'chevron-up');
  }, [props.isCollapsed]);

  const collapseClick = () => {
    if (props.link.subLevel) {
      props.onCollapseChange?.(props.link.url);
    }
  };

  const navbarIcon = (
    <div className={`navbar-icon navbar-icon--${size} ${horizontalCollapsed ? 'navbar-icon--horizontal-collapsed' : ''}`}>
      {props.link.icon ? <UQIcon icon={props.link.icon} /> : null}
    </div>
  );

  const renderLink = () => {
    if (props.renderLink) {
      if (horizontalCollapsed) {
        return props.renderLink(
          props.link,
          navbarIcon
        );
      } else {
        return props.renderLink(
          props.link,
          <div
            className={`navbar-item-base navbar-item-base--${size} ${isActive(props.link.url) ? 'active' : ''}`}
            onClick={collapseClick}
          >
            {navbarIcon}
            <div className="navbar-link">{props.link.text}</div>
          </div>
        );
      }
    }

    console.error('NavbarItem: renderLink function is required to render links.');
    return null;
  };

  return (
    <div className={`navbar-item navbar-item--${size} ${horizontalCollapsed ? 'navbar-item--horizontal-collapsed' : ''} ${!collapsed && props.link.subLevel ? 'non-collapsed' : ''}`}>
      {props.link.subLevel && !horizontalCollapsed ? (
        <div className={`navbar-item-base navbar-item-base--${size}`} onClick={collapseClick}>
          {navbarIcon}
          <div className="navbar-link collapser">
            <div>{props.link.text}</div>
            <UQIcon icon={collapserIcon} />
          </div>
        </div>
      ) : (
        renderLink()
      )}

      {/* Don't show submenu in horizontal collapsed mode */}
      {!horizontalCollapsed && (
        <div className={`navbar-submenu navbar-submenu-${props.link.url} ${collapsed ? 'collapsed' : 'expanded'}`}>
          {props.link.subLevel?.map((subLink) => (
            <NavbarSubitem
              key={subLink.url}
              link={subLink}
              location={props.location}
              renderLink={props.renderLink}
              size={size}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(NavbarItem);
